import { useState } from "react";

const EnterText = (params: {
    type?: string,
    height?: string,
    width?: string,
    placeholder?: string,
    func?: (ele: string) => void,
    [key: string]: any
} = {
        type: 'text',
        height: '100px',
        width: '25px',
        placeholder: 'enter text'
    }) => {

    const [inputText, inputSetText] = useState('');


    const { type, height, width, placeholder, func, ...props } = params;

    const handleChange = (e: any) => {
        inputSetText(e.target.value);
        if (func) {
            console.log("EnterText : ", e.target.value);
            func(e.target.value);
        };
        return true;
    }

    return <>
        <input
            style={{ width, height }}
            type={type}
            placeholder={placeholder}
            value={inputText}
            onChange={handleChange}
            {...props}
        >
        </input>
    </>
};

export default EnterText;
